import useAppContext from "utilities/hooks/useAppContext";
import AgricultureStatsPropertyView from "./AgricultureStatsPropertyView";
import { InvestmentResult } from "types/agriculture/states-type";
import AgricultureStatsSectionView from "./AgricultureStatsSectionView";

const AgricultureStatsInvestment = (props: { investment: InvestmentResult | undefined | null }) => {
    const context = useAppContext();

    if (!props.investment) {
        return <></>;
    }

    return <AgricultureStatsSectionView title="agriculture.stats.investment">
        <div className="flex flex-wrap">
            <AgricultureStatsPropertyView label="agriculture.stats.expenses" value={props.investment?.totalExpense} propertyType="money" />
            <AgricultureStatsPropertyView label="agriculture.stats.interactions" value={props.investment?.totalCount} propertyType="number" />
        </div>
    </AgricultureStatsSectionView>
};

export default AgricultureStatsInvestment;
